import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap-5';

import FilterRow from '../components/filter_row';
import ReorderableTable from 'components/reorderable_table/reorderable_table';
import { updateFilterOrder, updateFilter, savePluginSetFilters, addFilter } from '../actions/index';
import { filter, isEqual } from 'lodash';

export class PluginSetFilters extends React.Component {
  static propTypes = {
    addFilter: PropTypes.func.isRequired,
    defaultPluginFilters: PropTypes.array,
    filterFieldOptions: PropTypes.object.isRequired,
    pluginSet: PropTypes.shape({
      id: PropTypes.number,
      pluginFilters: PropTypes.array
    }).isRequired,
    propertyTypes: PropTypes.object.isRequired,
    savePluginSetFilters: PropTypes.func.isRequired,
    updateFilter: PropTypes.func.isRequired,
    updateFilterOrder: PropTypes.func.isRequired
  };

  state = {
    persistedPluginSet: this.props.pluginSet,
    saving: false,
    saved: false
  };

  saveFilters = () => {
    this.setState({ saving: true });
    this.props.savePluginSetFilters(
      this.props.pluginSet.id,
      this.props.pluginSet.pluginFilters,
      this.props.defaultPluginFilters,
      () => {
        this.setState({ saved: true, saving: false, persistedPluginSet: this.props.pluginSet });
        setTimeout(() => this.setState({ saved: false }), 3000);
      });
  };

  activeFilters = () => {
    return filter(this.props.pluginSet.pluginFilters, f => !f._destroy);
  };

  hasPendingDestroys = () => {
    return this.props.pluginSet.pluginFilters.some(f => f._destroy && !f.isDefault && !f.isNew);
  };

  hasBlankActiveFilters = () => {
    return this.activeFilters().some(f => !f.filterField);
  };

  renderFilters() {
    return this.activeFilters().map((item) => {
      if (item._destroy) {
        return null;
      } else {
        return (
          <FilterRow
            filterFieldOptions={this.props.filterFieldOptions}
            filterModel={item}
            key={item.id}
            propertyTypes={this.props.propertyTypes}
            onUpdate={this.props.updateFilter}
          />
        );
      }

    });
  }

  isDirty() {
    return !isEqual(this.props.pluginSet, this.state.persistedPluginSet);
  }

  renderSaveButton() {
    if (this.state.saved) {
      return (
        <div className="text-success">
          <i className="fas fa-check"></i> Changes Saved
        </div>
      );
    } else if (this.isDirty() && !this.hasBlankActiveFilters() &&
      (this.activeFilters().length > 0 || this.hasPendingDestroys())) {
      const buttonText = this.state.saving ? 'Saving...' : 'Save Changes';
      return (
        <button
          className="btn btn-primary btn-sm"
          disabled={this.state.saving}
          name="save"
          onClick={this.saveFilters}
        >
          {buttonText}
        </button>
      );
    } else {
      return null;
    }
  }

  renderSaveError() {
    return (
      <div className="text-danger collapse js-save-error">
        <i className="fas fa-exclamation-circle"></i> We could not save your changes.
      </div>
    );
  }

  renderBody() {
    if (this.activeFilters().length == 0) {
      return (
        <Card className="mb-3 js-empty-message">
          <Card.Body className="text-center my-4 p-0">
            <p className="fs-large text-muted my-2">
              {this.hasPendingDestroys()
                ? 'Save Changes to use the default filters.'
                : 'Using the default filters. Add a new filter to override the defaults.'}
            </p>
          </Card.Body>
        </Card>
      );
    } else {
      return (
        <div className="table-container mb-3">
          <ReorderableTable
            itemClassName="cursor-move align-middle"
            tableClassName="table table-hover"
            onReorder={this.props.updateFilterOrder}
          >
            {this.renderFilters()}
          </ReorderableTable>
        </div>
      );
    }
  }

  render() {
    return (
      <div>
        { this.renderBody() }
        <div className="d-flex justify-content-between align-items-center">
          <div className="links">
            <button
              className="btn btn-primary btn-sm"
              onClick={this.props.addFilter}
            >
              + Add New Field
            </button>
          </div>
          <div className="d-flex align-items-center gap-2">
            { this.renderSaveButton() }
            { this.renderSaveError() }
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ pluginSet }) {
  return { pluginSet };
}
const actions = { updateFilterOrder, updateFilter, savePluginSetFilters, addFilter };

export default connect(mapStateToProps, actions)(PluginSetFilters);
